// extracted by mini-css-extract-plugin
export default {"orderComponentsAndPrice":"card-order_orderComponentsAndPrice__kSy1A","orderComponents":"card-order_orderComponents__kAh9R","cardOrder":"card-order_cardOrder__DAIPH"};